import { render, staticRenderFns } from "./Graph.vue?vue&type=template&id=56c0876c&scoped=true&"
import script from "./Graph.vue?vue&type=script&lang=ts&"
export * from "./Graph.vue?vue&type=script&lang=ts&"
import style0 from "./Graph.vue?vue&type=style&index=0&id=56c0876c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0876c",
  null
  
)

export default component.exports